<template>
  <v-container class="guide-admin">
    <p class="text-center title mt-6">Інструкція для психологів</p>
    <p class="text-center grey--text">
      Психологи бачать це у своєму кабінеті у вкладці «Інструкція та налаштування». Про кожне нове оновлення їм світиться лічильник у меню.
    </p>

    <v-card outlined class="pa-4 mt-4">
      <p class="font-weight-bold mb-2">Посилання на інструкцію (Google Диск)</p>
      <div class="d-flex flex-wrap guide-admin__row">
        <v-text-field
          v-model="url"
          placeholder="https://drive.google.com/..."
          dense
          outlined
          hide-details
          clearable
          class="guide-admin__url"
        ></v-text-field>
        <v-btn color="primary" depressed :loading="savingUrl" @click="saveUrl">Зберегти</v-btn>
      </div>
      <p class="caption grey--text mt-2 mb-0">Відкрийте доступ до папки чи документа «Усі, хто має посилання», інакше психологи не побачать вміст.</p>
    </v-card>

    <v-card outlined class="pa-4 mt-4">
      <p class="font-weight-bold mb-3">{{ form.id ? "Редагувати оновлення" : "Нове оновлення" }}</p>
      <v-text-field v-model="form.title" label="Заголовок" dense outlined counter="200" maxlength="200"></v-text-field>
      <v-textarea v-model="form.body" label="Текст (необов'язково)" dense outlined auto-grow rows="3" counter="5000" maxlength="5000"></v-textarea>
      <v-text-field v-model="form.link" label="Посилання «Детальніше» (необов'язково)" dense outlined clearable></v-text-field>
      <div class="d-flex flex-wrap guide-admin__row">
        <v-btn color="primary" depressed :loading="savingUpdate" @click="saveUpdate">{{ form.id ? "Зберегти" : "Опублікувати" }}</v-btn>
        <v-btn v-if="form.id" text @click="resetForm">Скасувати</v-btn>
      </div>
    </v-card>

    <p class="font-weight-bold mt-8 mb-2">Опубліковані оновлення</p>
    <p v-if="!updates.length" class="grey--text">Оновлень ще немає</p>
    <v-card v-for="item in updates" :key="item.id" outlined class="pa-4 mb-3">
      <div class="caption grey--text">{{ dateOf(item.published_at) }}</div>
      <div class="font-weight-bold">{{ item.title }}</div>
      <p v-if="item.body" class="guide-admin__text mb-1">{{ item.body }}</p>
      <a v-if="item.link" :href="item.link" target="_blank" rel="noopener" class="caption">{{ item.link }}</a>
      <div class="d-flex guide-admin__row mt-2">
        <v-btn x-small outlined @click="edit(item)">Змінити</v-btn>
        <v-btn x-small text color="red" @click="remove(item)">Видалити</v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import ApiClient from "@/libs/http-client";

export default {
  name: "GuideAdmin",
  metaInfo() {
    return { title: "Платформа / Інструкція" };
  },
  data() {
    return {
      url: "",
      updates: [],
      form: { title: "", body: "", link: "" },
      savingUrl: false,
      savingUpdate: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      return ApiClient.get("api/admin/guide").then((response) => {
        this.url = response.data.data.url || "";
        this.updates = response.data.data.updates;
      });
    },
    toast(text) {
      Vue.swal({ target: document.getElementById("main"), text, icon: "success", timer: 2500, toast: true, position: "top-right", showConfirmButton: false });
    },
    saveUrl() {
      this.savingUrl = true;
      ApiClient.post("api/admin/guide/url", { url: (this.url || "").trim() || null })
        .then((response) => {
          if (response) this.toast(response.data.message);
        })
        .finally(() => {
          this.savingUrl = false;
        });
    },
    resetForm() {
      this.form = { title: "", body: "", link: "" };
    },
    edit(item) {
      this.form = { id: item.id, title: item.title, body: item.body || "", link: item.link || "" };
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    saveUpdate() {
      this.savingUpdate = true;
      const url = this.form.id ? `api/admin/guide/updates/${this.form.id}` : "api/admin/guide/updates";
      const payload = { title: this.form.title, body: this.form.body || null, link: (this.form.link || "").trim() || null };
      ApiClient.post(url, payload)
        .then((response) => {
          if (!response) return;
          this.toast(response.data.message);
          this.resetForm();
          this.load();
        })
        .finally(() => {
          this.savingUpdate = false;
        });
    },
    remove(item) {
      if (!window.confirm(`Видалити оновлення «${item.title}»?`)) return;
      ApiClient.delete(`api/admin/guide/updates/${item.id}`).then((response) => {
        this.toast(response.data.message);
        this.load();
      });
    },
    dateOf(value) {
      return new Date(value).toLocaleString("uk-UA", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
    },
  },
};
</script>

<style lang="scss" scoped>
.guide-admin {
  max-width: 900px;
}
.guide-admin__row {
  gap: 10px;
}
.guide-admin__url {
  flex: 1 1 320px;
}
.guide-admin__text {
  white-space: pre-line;
}
</style>
